import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { ArrowLeft, ScanLine } from "lucide-react";
import { getMeta, setMeta, META } from "@/lib/db";
import { resetReader, getRFIDReader, resolveReaderMode } from "@/lib/rfid/IRFIDReader";
import { ScanCTA } from "@/components/ScanCTA";
import { toast } from "sonner";

export default function ReaderSettings() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("simulator");
  const [presentColor, setPresentColor] = useState("#2F6FED");
  const [lastChip, setLastChip] = useState("-");
  const [status, setStatus] = useState("disconnected");

  useEffect(() => {
    (async () => {
      setMode(await resolveReaderMode());
      setPresentColor(await getMeta(META.PRESENT_COLOR, "#2F6FED"));
    })();
  }, []);

  const save = async (newMode) => {
    await setMeta(META.READER_MODE, newMode);
    await resetReader();
    setMode(newMode);
    toast.success("Modo actualizado");
    const r = await getRFIDReader();
    setStatus(r.getStatus?.() || "connected");
  };

  return (
    <div className="max-w-xl mx-auto space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" onClick={()=>navigate("/ajustes")} className="h-9 px-2"><ArrowLeft size={18} /></Button>
        <h1 className="font-heading text-2xl font-semibold">Lector RFID</h1>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-base flex items-center gap-2"><ScanLine size={16} /> Modo de conexión</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          <div>
            <Label>Modo</Label>
            <Select value={mode} onValueChange={save}>
              <SelectTrigger className="h-11" data-testid="reader-mode-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="simulator">Simulador (testing sin lector)</SelectItem>
                <SelectItem value="hid">Lector RFID (lector físico)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <ScanCTA testId="reader-test-scan" onChip={(c)=>setLastChip(c)} label="Probar lectura" />
          <div className="text-xs text-muted-foreground">
            <div>Último chip leído: <span className="font-mono">{lastChip}</span></div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle className="text-base">Estilo del inventario</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          <div>
            <Label>Color para "presente"</Label>
            <div className="flex items-center gap-3">
              <input type="color" value={presentColor} onChange={async (e)=>{ setPresentColor(e.target.value); await setMeta(META.PRESENT_COLOR, e.target.value); }} className="h-11 w-16 rounded-lg border border-border" data-testid="reader-present-color" />
              <code className="text-xs">{presentColor}</code>
            </div>
            <p className="text-xs text-muted-foreground mt-1">El default sigue las guidelines (azul accesible). Cambialo si querés.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
